var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-12 col-lg-4 order-lg-2" },
        [
          _c("account-sidebar", {
            attrs: {
              lng: _vm.lng,
              mainlng: _vm.mainlng,
              translations: _vm.translations,
              accountlink: _vm.accountlink,
              logoutlink: _vm.logoutlink,
              isaccountroute: _vm.isaccountroute,
              account: _vm.accountSidebar,
              refillaccountlink: _vm.refillaccountlink,
            },
            on: {
              AvatarChanged: function ($event) {
                return _vm.changeAvatar($event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-lg-8 order-lg-1" },
        [
          _vm._l(_vm.preparedNotifications, function (notification, key) {
            return _c("notification-alert-block", {
              key: key,
              attrs: {
                notification: notification,
                setnotificationlink: _vm.setnotificationlink,
              },
            })
          }),
          _vm._v(" "),
          _c("div", { staticClass: "simple__block" }, [
            _c("h3", { staticClass: "h5" }, [
              _vm._v(
                _vm._s(_vm.get_translation_constant("text_personal_data"))
              ),
            ]),
            _vm._v(" "),
            _c(
              "form",
              { attrs: { action: "" } },
              [
                _vm.account.location_id == 1
                  ? [
                      _c("div", { staticClass: "row align-items-end" }, [
                        _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("first_name"),
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_firstname_cyrillic"
                                    )
                                  )
                                ),
                                _c("sup", [_vm._v("*")]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.first_name,
                                    expression: "form.first_name",
                                  },
                                ],
                                staticClass: "form__control",
                                attrs: {
                                  placeholder: _vm.get_translation_constant(
                                    "text_your_firstname"
                                  ),
                                  type: "text",
                                },
                                domProps: { value: _vm.form.first_name },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form,
                                      "first_name",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasErrorMessage("first_name")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.hasErrorMessage("first_name")
                                        ) +
                                        "\n                                "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("last_name"),
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_lastname_cyrillic"
                                    )
                                  )
                                ),
                                _c("sup", [_vm._v("*")]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.last_name,
                                    expression: "form.last_name",
                                  },
                                ],
                                staticClass: "form__control",
                                attrs: {
                                  placeholder:
                                    _vm.get_translation_constant(
                                      "text_your_lastname"
                                    ),
                                  type: "text",
                                },
                                domProps: { value: _vm.form.last_name },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form,
                                      "last_name",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasErrorMessage("last_name")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.hasErrorMessage("last_name")
                                        ) +
                                        "\n                                "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row align-items-end" }, [
                          _c("div", { staticClass: "col-12 col-lg-6" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form__col",
                                class: _vm.hasError("first_name_latin"),
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.get_translation_constant(
                                        "text_firstname_latin"
                                      )
                                    )
                                  ),
                                  _c("sup", [_vm._v("*")]),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.first_name_latin,
                                      expression: "form.first_name_latin",
                                    },
                                  ],
                                  staticClass: "form__control",
                                  attrs: {
                                    placeholder: _vm.get_translation_constant(
                                      "text_your_firstname"
                                    ),
                                    type: "text",
                                  },
                                  domProps: {
                                    value: _vm.form.first_name_latin,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "first_name_latin",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.hasErrorMessage("first_name_latin")
                                  ? _c("div", { staticClass: "form__error" }, [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.hasErrorMessage(
                                              "first_name_latin"
                                            )
                                          ) +
                                          "\n                                    "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-lg-6" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form__col",
                                class: _vm.hasError("last_name_latin"),
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.get_translation_constant(
                                        "text_lastname_latin"
                                      )
                                    )
                                  ),
                                  _c("sup", [_vm._v("*")]),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.last_name_latin,
                                      expression: "form.last_name_latin",
                                    },
                                  ],
                                  staticClass: "form__control",
                                  attrs: {
                                    placeholder:
                                      _vm.get_translation_constant(
                                        "text_your_lastname"
                                      ),
                                    type: "text",
                                  },
                                  domProps: { value: _vm.form.last_name_latin },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "last_name_latin",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.hasErrorMessage("last_name_latin")
                                  ? _c("div", { staticClass: "form__error" }, [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.hasErrorMessage(
                                              "last_name_latin"
                                            )
                                          ) +
                                          "\n                                    "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("patronymic"),
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_patronymic_cyrillic"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.patronymic,
                                    expression: "form.patronymic",
                                  },
                                ],
                                staticClass: "form__control",
                                attrs: {
                                  placeholder:
                                    _vm.get_translation_constant(
                                      "text_patronymic"
                                    ),
                                  type: "text",
                                },
                                domProps: { value: _vm.form.patronymic },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form,
                                      "patronymic",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasErrorMessage("patronymic")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.hasErrorMessage("patronymic")
                                        ) +
                                        "\n                                "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("birthday"),
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_birthday"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("date-picker", {
                                staticClass: "form__control",
                                attrs: {
                                  locale: _vm.lng,
                                  config: {
                                    format: "DD-MM-YYYY",
                                    locale: _vm.lng,
                                  },
                                },
                                on: { "dp-hide": _vm.showDatePicker },
                                model: {
                                  value: _vm.form.birthday,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "birthday", $$v)
                                  },
                                  expression: "form.birthday",
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasErrorMessage("birthday")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.hasErrorMessage("birthday")
                                        ) +
                                        "\n                                "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]
                  : [
                      _c("div", { staticClass: "row align-items-end" }, [
                        _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("first_name_latin"),
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_firstname_latin"
                                    )
                                  )
                                ),
                                _c("sup", [_vm._v("*")]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.first_name_latin,
                                    expression: "form.first_name_latin",
                                  },
                                ],
                                staticClass: "form__control",
                                attrs: {
                                  placeholder: _vm.get_translation_constant(
                                    "text_your_firstname"
                                  ),
                                  type: "text",
                                },
                                domProps: { value: _vm.form.first_name_latin },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form,
                                      "first_name_latin",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasErrorMessage("first_name_latin")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.hasErrorMessage(
                                            "first_name_latin"
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("last_name_latin"),
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_lastname_latin"
                                    )
                                  )
                                ),
                                _c("sup", [_vm._v("*")]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.last_name_latin,
                                    expression: "form.last_name_latin",
                                  },
                                ],
                                staticClass: "form__control",
                                attrs: {
                                  placeholder:
                                    _vm.get_translation_constant(
                                      "text_your_lastname"
                                    ),
                                  type: "text",
                                },
                                domProps: { value: _vm.form.last_name_latin },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form,
                                      "last_name_latin",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasErrorMessage("last_name_latin")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.hasErrorMessage("last_name_latin")
                                        ) +
                                        "\n                                "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row align-items-end" }, [
                        _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("first_name"),
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_firstname_english"
                                    )
                                  )
                                ),
                                _c("sup", [_vm._v("*")]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.first_name,
                                    expression: "form.first_name",
                                  },
                                ],
                                staticClass: "form__control",
                                attrs: {
                                  placeholder: _vm.get_translation_constant(
                                    "text_your_firstname"
                                  ),
                                  type: "text",
                                },
                                domProps: { value: _vm.form.first_name },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form,
                                      "first_name",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasErrorMessage("first_name")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.hasErrorMessage("first_name")
                                        ) +
                                        "\n                                "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("last_name"),
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_lastname_english"
                                    )
                                  )
                                ),
                                _c("sup", [_vm._v("*")]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.last_name,
                                    expression: "form.last_name",
                                  },
                                ],
                                staticClass: "form__control",
                                attrs: {
                                  placeholder:
                                    _vm.get_translation_constant(
                                      "text_your_lastname"
                                    ),
                                  type: "text",
                                },
                                domProps: { value: _vm.form.last_name },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form,
                                      "last_name",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasErrorMessage("last_name")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.hasErrorMessage("last_name")
                                        ) +
                                        "\n                                "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("patronymic"),
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_patronymic"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.patronymic,
                                    expression: "form.patronymic",
                                  },
                                ],
                                staticClass: "form__control",
                                attrs: {
                                  placeholder:
                                    _vm.get_translation_constant(
                                      "text_patronymic"
                                    ),
                                  type: "text",
                                },
                                domProps: { value: _vm.form.patronymic },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form,
                                      "patronymic",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasErrorMessage("patronymic")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.hasErrorMessage("patronymic")
                                        ) +
                                        "\n                                "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("birthday"),
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_birthday"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("date-picker", {
                                staticClass: "form__control",
                                attrs: {
                                  locale: _vm.lng,
                                  config: {
                                    format: "DD-MM-YYYY",
                                    locale: _vm.lng,
                                  },
                                },
                                on: { "dp-hide": _vm.showDatePicker },
                                model: {
                                  value: _vm.form.birthday,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "birthday", $$v)
                                  },
                                  expression: "form.birthday",
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasErrorMessage("birthday")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.hasErrorMessage("birthday")
                                        ) +
                                        "\n                                "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ],
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form__col", class: _vm.hasError("gender") },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.get_translation_constant("text_sex"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row no-gutters radio_group__custom" },
                      _vm._l(_vm.genders, function (gender, index) {
                        return _c(
                          "div",
                          { staticClass: "col-auto radio_group__item" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.gender_id,
                                  expression: "form.gender_id",
                                },
                              ],
                              attrs: {
                                id: gender.title,
                                name: "sex",
                                type: "radio",
                              },
                              domProps: {
                                value: gender.id,
                                checked: _vm._q(_vm.form.gender_id, gender.id),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setGender(gender)
                                },
                                change: function ($event) {
                                  return _vm.$set(
                                    _vm.form,
                                    "gender_id",
                                    gender.id
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: gender.title } }, [
                              _vm._v(_vm._s(_vm.genderTitle(gender))),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.hasErrorMessage("gender")
                      ? _c("div", { staticClass: "form__error" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.hasErrorMessage("gender")) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form__address" },
                  [
                    _vm.account.location_id !== 1
                      ? _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("city_id"),
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_your_city"
                                    )
                                  )
                                ),
                                _c("sup", [_vm._v("*")]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "multiselect",
                                {
                                  staticClass: "form-control",
                                  attrs: {
                                    multiple: false,
                                    placeholder:
                                      _vm.get_translation_constant(
                                        "text_choose_city"
                                      ),
                                    options: _vm.cities,
                                    label: "title",
                                    selectLabel: "",
                                    deselectLabel: "",
                                    optionHeight: 48,
                                    showPointer: true,
                                  },
                                  on: {
                                    select: function ($event) {
                                      return _vm.setAccountCity()
                                    },
                                  },
                                  model: {
                                    value: _vm.form.city,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "city", $$v)
                                    },
                                    expression: "form.city",
                                  },
                                },
                                [void 0],
                                2
                              ),
                              _vm._v(" "),
                              _vm.hasErrorMessage("city_id")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.hasErrorMessage("city_id")) +
                                        "\n                            "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ])
                      : _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("form.city_ref"),
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_your_city"
                                    )
                                  )
                                ),
                                _c("sup", [_vm._v("*")]),
                              ]),
                              _vm._v(" "),
                              _c("multiselect", {
                                staticClass: "form-control",
                                attrs: {
                                  multiple: false,
                                  placeholder: _vm.get_translation_constant(
                                    "text_enter_street_in_ukraine_letters"
                                  ),
                                  options: _vm.form.novaPoshtaCities,
                                  label: "Description",
                                  selectLabel: "",
                                  deselectLabel: "",
                                  optionHeight: 48,
                                  showPointer: true,
                                },
                                on: {
                                  "search-change": _vm.asyncCities,
                                  select: _vm.loadStreets,
                                },
                                model: {
                                  value: _vm.form.city_ref,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "city_ref", $$v)
                                  },
                                  expression: "form.city_ref",
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasErrorMessage("city_ref")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.get_translation_constant(
                                            "text_field_is_required"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                    _vm._v(" "),
                    _vm.account.location_id === 1
                      ? _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("form.street"),
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_delivery_street"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("multiselect", {
                                staticClass: "form-control",
                                attrs: {
                                  multiple: false,
                                  placeholder: _vm.get_translation_constant(
                                    "text_enter_street_in_ukraine_letters"
                                  ),
                                  options: _vm.form.streets,
                                  label: "Description",
                                  selectLabel: "",
                                  deselectLabel: "",
                                  optionHeight: 48,
                                  showPointer: true,
                                },
                                on: { "search-change": _vm.searchTimeOut },
                                model: {
                                  value: _vm.form.street,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "street", $$v)
                                  },
                                  expression: "form.street",
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasErrorMessage(
                                "deliveryMethod.novaPoshta.street"
                              )
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.get_translation_constant(
                                            "text_field_is_required"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.account.location_id === 1
                      ? [
                          _c("div", { staticClass: "col-12 col-lg-6" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form__col",
                                class: _vm.hasError("buildingNumber"),
                              },
                              [
                                _c("label", { attrs: { for: "address" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.get_translation_constant(
                                        "text_choose_house"
                                      )
                                    )
                                  ),
                                  _c("sup", [_vm._v("*")]),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.buildingNumber,
                                      expression: "form.buildingNumber",
                                    },
                                  ],
                                  staticClass: "form__control",
                                  attrs: {
                                    id: "buildingNumber",
                                    name: "buildingNumber",
                                    type: "text",
                                    placeholder:
                                      _vm.get_translation_constant(
                                        "text_choose_house"
                                      ),
                                  },
                                  domProps: { value: _vm.form.buildingNumber },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "buildingNumber",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.hasErrorMessage("buildingNumber")
                                  ? _c("div", { staticClass: "form__error" }, [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.hasErrorMessage(
                                              "buildingNumber"
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-lg-6" }, [
                            _c("div", { staticClass: "form__col" }, [
                              _c("label", { attrs: { for: "flat" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_your_flat"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.flat,
                                    expression: "form.flat",
                                  },
                                ],
                                staticClass: "form__control",
                                attrs: {
                                  id: "flat",
                                  name: "flat",
                                  type: "text",
                                  placeholder:
                                    _vm.get_translation_constant(
                                      "text_enter_flat"
                                    ),
                                },
                                domProps: { value: _vm.form.flat },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form,
                                      "flat",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-lg-6" }, [
                            _c("div", { staticClass: "form__col" }, [
                              _c("label", { attrs: { for: "postcode" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_your_postcode"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.postcode,
                                    expression: "form.postcode",
                                  },
                                ],
                                staticClass: "form__control",
                                attrs: {
                                  id: "postcode",
                                  name: "postcode",
                                  type: "text",
                                  placeholder: _vm.get_translation_constant(
                                    "text_enter_postcode"
                                  ),
                                },
                                domProps: { value: _vm.form.postcode },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form,
                                      "postcode",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.account.location_id !== 1
                      ? _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("address"),
                            },
                            [
                              _c("label", { attrs: { for: "address" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_your_address"
                                    )
                                  )
                                ),
                                _c("sup", [_vm._v("*")]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.address,
                                    expression: "form.address",
                                  },
                                ],
                                staticClass: "form__control",
                                attrs: {
                                  id: "address",
                                  name: "address",
                                  type: "text",
                                  placeholder: _vm.get_translation_constant(
                                    "text_enter_address_latin_letters"
                                  ),
                                },
                                domProps: { value: _vm.form.address },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form,
                                      "address",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasErrorMessage("address")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.hasErrorMessage("address")) +
                                        "\n                            "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-lg-6" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form__col",
                        class: _vm.hasError("email"),
                      },
                      [
                        _c("label", { attrs: { for: "email" } }, [
                          _vm._v(
                            _vm._s(_vm.get_translation_constant("text_email"))
                          ),
                          _c("sup", [_vm._v("*")]),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.email,
                              expression: "form.email",
                            },
                          ],
                          staticClass: "form__control",
                          attrs: {
                            id: "email",
                            name: "email",
                            type: "email",
                            placeholder:
                              _vm.get_translation_constant("text_entry_email"),
                          },
                          domProps: { value: _vm.form.email },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.form, "email", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.hasErrorMessage("email")
                          ? _c("div", { staticClass: "form__error" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.hasErrorMessage("email")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-lg-6" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form__col",
                        class: _vm.hasError("phone_number"),
                      },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.get_translation_constant("text_phone"))
                          ),
                          _c("sup", [_vm._v("*")]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "phone__block" },
                          [
                            _c("multiselect", {
                              staticClass: "form-control",
                              attrs: {
                                multiple: false,
                                placeholder: "",
                                options: _vm.locationPrefixes,
                                label: "title",
                                selectLabel: "",
                                deselectLabel: "",
                                optionHeight: 48,
                                showPointer: true,
                                searchable: false,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "singleLabel",
                                  fn: function (props) {
                                    return [
                                      _c("img", {
                                        staticClass: "option__image",
                                        attrs: {
                                          src: props.option.image,
                                          width: "16",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "option__title" },
                                        [_vm._v(_vm._s(props.option.title))]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "option",
                                  fn: function (props) {
                                    return [
                                      _c("img", {
                                        staticClass: "option__image",
                                        attrs: {
                                          src: props.option.image,
                                          width: "16",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "option__title" },
                                        [_vm._v(_vm._s(props.option.title))]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.form.phone_prefix,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "phone_prefix", $$v)
                                },
                                expression: "form.phone_prefix",
                              },
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.phone_number,
                                  expression: "form.phone_number",
                                },
                              ],
                              staticClass: "form__control type_tel",
                              attrs: { type: "tel" },
                              domProps: { value: _vm.form.phone_number },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "phone_number",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.hasErrorMessage("phone_number")
                          ? _c("div", { staticClass: "form__error" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.hasErrorMessage("phone_number")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check form-switch" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.use_sms,
                        expression: "form.use_sms",
                      },
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      checked: "",
                      id: "notification",
                      name: "notification",
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.form.use_sms)
                        ? _vm._i(_vm.form.use_sms, null) > -1
                        : _vm.form.use_sms,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.form.use_sms,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(_vm.form, "use_sms", $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "use_sms",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "use_sms", $$c)
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "notification" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.get_translation_constant("text_get_sms"))
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check form-switch" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.use_terminal,
                        expression: "form.use_terminal",
                      },
                    ],
                    staticClass: "form-check-input",
                    attrs: { id: "code", name: "code", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.form.use_terminal)
                        ? _vm._i(_vm.form.use_terminal, null) > -1
                        : _vm.form.use_terminal,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.form.use_terminal,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "use_terminal",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "use_terminal",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "use_terminal", $$c)
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "form-check-label", attrs: { for: "code" } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.get_translation_constant("text_get_terminal_code")
                        )
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-check form-switch" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.auto_declaration,
                        expression: "form.auto_declaration",
                      },
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      id: "autoDeclaration",
                      name: "autodeclaration",
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.form.auto_declaration)
                        ? _vm._i(_vm.form.auto_declaration, null) > -1
                        : _vm.form.auto_declaration,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.form.auto_declaration,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "auto_declaration",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "auto_declaration",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "auto_declaration", $$c)
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "autoDeclaration" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.get_translation_constant(
                            "text_get_auto_declaration"
                          )
                        )
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form__hr" }),
                _vm._v(" "),
                _c("div", { staticClass: "row align-items-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "collapse col-12",
                      attrs: { id: "changePassword" },
                    },
                    [
                      _c("div", { staticClass: "card card-body" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12 col-lg-6" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form__col",
                                class: _vm.hasError("old_password"),
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.get_translation_constant(
                                        "text_old_password"
                                      )
                                    ) +
                                      "\n                                            "
                                  ),
                                  _c("sup", [_vm._v("*")]),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.old_password,
                                      expression: "form.old_password",
                                    },
                                  ],
                                  staticClass: "form__control",
                                  attrs: {
                                    id: "old_password",
                                    name: "old_password",
                                    type: "password",
                                    placeholder:
                                      _vm.get_translation_constant(
                                        "text_old_password"
                                      ),
                                  },
                                  domProps: { value: _vm.form.old_password },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "old_password",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.hasErrorMessage("old_password")
                                  ? _c("div", { staticClass: "form__error" }, [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(
                                            _vm.hasErrorMessage("old_password")
                                          ) +
                                          "\n                                        "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12 col-lg-6" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form__col",
                                class: _vm.hasError("new_password"),
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.get_translation_constant(
                                        "text_new_password"
                                      )
                                    )
                                  ),
                                  _c("sup", [_vm._v("*")]),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.new_password,
                                      expression: "form.new_password",
                                    },
                                  ],
                                  staticClass: "form__control",
                                  attrs: {
                                    id: "new_password",
                                    name: "new_password",
                                    type: "password",
                                    placeholder:
                                      _vm.get_translation_constant(
                                        "text_new_password"
                                      ),
                                  },
                                  domProps: { value: _vm.form.new_password },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "new_password",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.hasErrorMessage("new_password")
                                  ? _c("div", { staticClass: "form__error" }, [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(
                                            _vm.hasErrorMessage("new_password")
                                          ) +
                                          "\n                                        "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-lg-6" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form__col",
                                class: _vm.hasError("new_password_check"),
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.get_translation_constant(
                                        "text_confirm_password"
                                      )
                                    ) +
                                      "\n                                            *"
                                  ),
                                  _c("sup", [_vm._v("*")]),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.new_password_check,
                                      expression: "form.new_password_check",
                                    },
                                  ],
                                  staticClass: "form__control",
                                  attrs: {
                                    id: "new_password_check",
                                    name: "new_password_check",
                                    placeholder: _vm.get_translation_constant(
                                      "text_new_password_check"
                                    ),
                                    type: "password",
                                  },
                                  domProps: {
                                    value: _vm.form.new_password_check,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "new_password_check",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.hasErrorMessage("new_password_check")
                                  ? _c("div", { staticClass: "form__error" }, [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(
                                            _vm.hasErrorMessage(
                                              "new_password_check"
                                            )
                                          ) +
                                          "\n                                        "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "row align-items-center justify-content-between",
                  },
                  [
                    _c("div", { staticClass: "col-12 col-md-6 mb-3 mb-md-0" }, [
                      _c(
                        "a",
                        {
                          ref: "changePasswordId",
                          staticClass: "change__password",
                          attrs: {
                            href: "#changePassword",
                            "aria-controls": "changePassword",
                            "aria-expanded": "false",
                            "data-bs-toggle": "collapse",
                            role: "button",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.get_translation_constant(
                                "text_change_password"
                              )
                            )
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-12 col-md-auto text-lg-right d-flex",
                      },
                      [
                        _c("input", {
                          staticClass: "btn btn__large btn__green btn__block",
                          attrs: { type: "submit" },
                          domProps: {
                            value:
                              _vm.get_translation_constant(
                                "text_save_settings"
                              ),
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.submitForm()
                            },
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple__block" }, [
            _c("h3", { staticClass: "h5 d-flex align-items-center" }, [
              _vm._v(_vm._s(_vm.get_translation_constant("text_agents"))),
              _c(
                "span",
                {
                  staticClass: "tooltip__block tooltip__bottom tooltip__modal",
                },
                [
                  _c("span", { staticClass: "tooltip__block_trigger" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 14 14",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z",
                            fill: "#515154",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "tooltip__block_overlay" }, [
                    _c("span", { staticClass: "tooltip__block_inner" }, [
                      _c("span", { staticClass: "tooltip__block_close" }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.get_translation_constant(
                              "text_creating_agents_is_relevant"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c("a", { attrs: { href: "#" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.get_translation_constant(
                                "text_learn_more_about_agents"
                              )
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "table table__agents" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("#")]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(
                      _vm._s(_vm.get_translation_constant("text_name_surname"))
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.account.location_id !== 1
                    ? _c("th", [
                        _vm._v(
                          _vm._s(_vm.get_translation_constant("text_city"))
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(
                      _vm._s(_vm.get_translation_constant("text_address"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(_vm._s(_vm.get_translation_constant("text_phone"))),
                  ]),
                  _vm._v(" "),
                  _vm.account.location_id === 1
                    ? _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.get_translation_constant("text_parcel_count")
                          )
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("th"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.agents, function (agent, key) {
                  return _c("tr", [
                    _c("td", [_vm._v(_vm._s(key + 1))]),
                    _vm._v(" "),
                    _vm.account.location_id === 1
                      ? _c("td", [
                          _vm._v(
                            _vm._s(agent.first_name) +
                              " " +
                              _vm._s(agent.last_name) +
                              " " +
                              _vm._s(agent.patronymic)
                          ),
                        ])
                      : _c("td", [
                          _vm._v(
                            _vm._s(agent.first_name_latin) +
                              " " +
                              _vm._s(agent.last_name_latin)
                          ),
                        ]),
                    _vm._v(" "),
                    _vm.account.location_id !== 1
                      ? _c("td", [_vm._v(_vm._s(_vm.getCity(agent)))])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(agent.street) +
                          " " +
                          _vm._s(agent.house) +
                          " " +
                          _vm._s(agent.apartment)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "tel:" + agent.phone_prefix + agent.phone_number,
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(agent.phone_prefix) +
                              _vm._s(agent.phone_number)
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.account.location_id === 1
                      ? _c("td", [_vm._v(_vm._s(agent.totals.cnt))])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "table__actions d-flex justify-content-end",
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "javascript:void(0)",
                                title: "Remove",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.removeAgent(agent)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M15.2 16.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V3.7c0-1.02-.72-1.69-1.86-1.69H8.61c-1.14 0-1.84.67-1.84 1.69v1.07H3.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM7.96 3.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM6.73 16.93a.75.75 0 01-.77-.73L5.44 5.84h9.1l-.5 10.36a.74.74 0 01-.76.73H6.73zm5.46-1.26c.25 0 .43-.2.44-.47l.22-7.56c0-.27-.18-.47-.44-.47-.22 0-.42.2-.42.46l-.23 7.57c0 .26.18.47.43.47zm-4.38 0c.26 0 .44-.21.43-.47l-.22-7.57c0-.25-.2-.46-.43-.46-.26 0-.44.2-.43.47l.23 7.56c0 .27.18.47.42.47zm2.64-.47V7.63c0-.25-.2-.46-.44-.46-.25 0-.45.2-.45.46v7.57c0 .26.2.47.45.47.23 0 .44-.21.44-.47z",
                                      fill: "#515154",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-md-flex justify-content-end" }, [
              _c(
                "a",
                {
                  staticClass:
                    "btn btn__large btn__blue_border no_width d-block",
                  attrs: {
                    href: "javascript:void(0)",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#addAgent",
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.get_translation_constant("text_add_agent")) +
                      "\n                    +"
                  ),
                ]
              ),
            ]),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade modal__custom",
          attrs: {
            id: "addAgent",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "addAgenttitle",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              attrs: { role: "document" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h4",
                    {
                      staticClass: "h5 modal-title",
                      attrs: { id: "addAgenttitle" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.get_translation_constant("text_add_agent"))
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      id: "closeAgentBtn",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("form", { attrs: { action: "" } }, [
                    _c("h5", { staticClass: "h_text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.get_translation_constant("text_personal_data")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _vm.account.location_id === 1
                          ? [
                              _c("div", { staticClass: "col-12 col-lg-6" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form__col",
                                    class: _vm.hasError("newAgent_first_name"),
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.get_translation_constant(
                                            "text_firstname_cyrillic"
                                          )
                                        ) +
                                          "\n                                            "
                                      ),
                                      _c("sup", [_vm._v("*")]),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newAgent.first_name,
                                          expression: "newAgent.first_name",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        name: "full_name_ro",
                                        placeholder:
                                          _vm.get_translation_constant(
                                            "text_firstname_english"
                                          ),
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.newAgent.first_name,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.newAgent,
                                            "first_name",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.hasErrorMessage("newAgent_first_name")
                                      ? _c(
                                          "div",
                                          { staticClass: "form__error" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.hasErrorMessage(
                                                    "newAgent_first_name"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-lg-6" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form__col",
                                    class: _vm.hasError("newAgent_last_name"),
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.get_translation_constant(
                                            "text_firstname_cyrillic"
                                          )
                                        ) +
                                          "\n                                            "
                                      ),
                                      _c("sup", [_vm._v("*")]),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newAgent.last_name,
                                          expression: "newAgent.last_name",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        name: "full_name_ro",
                                        placeholder:
                                          _vm.get_translation_constant(
                                            "text_lastname_english"
                                          ),
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.newAgent.last_name,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.newAgent,
                                            "last_name",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.hasErrorMessage("newAgent_last_name")
                                      ? _c(
                                          "div",
                                          { staticClass: "form__error" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.hasErrorMessage(
                                                    "newAgent_last_name"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-lg-6" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form__col",
                                    class: _vm.hasError(
                                      "newAgent_first_name_latin"
                                    ),
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.get_translation_constant(
                                            "text_firstname_latin"
                                          )
                                        ) +
                                          "\n                                            "
                                      ),
                                      _c("sup", [_vm._v("*")]),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newAgent.first_name_latin,
                                          expression:
                                            "newAgent.first_name_latin",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        name: "full_name_ro",
                                        placeholder:
                                          _vm.get_translation_constant(
                                            "text_firstname_latin"
                                          ),
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.newAgent.first_name_latin,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.newAgent,
                                            "first_name_latin",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.hasErrorMessage(
                                      "newAgent_first_name_latin"
                                    )
                                      ? _c(
                                          "div",
                                          { staticClass: "form__error" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.hasErrorMessage(
                                                    "newAgent_first_name_latin"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-lg-6" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form__col",
                                    class: _vm.hasError(
                                      "newAgent_last_name_latin"
                                    ),
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.get_translation_constant(
                                            "text_lastname_latin"
                                          )
                                        ) +
                                          "\n                                            "
                                      ),
                                      _c("sup", [_vm._v("*")]),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newAgent.last_name_latin,
                                          expression:
                                            "newAgent.last_name_latin",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        name: "full_name_ro",
                                        placeholder:
                                          _vm.get_translation_constant(
                                            "text_lastname_latin"
                                          ),
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.newAgent.last_name_latin,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.newAgent,
                                            "last_name_latin",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.hasErrorMessage(
                                      "newAgent_last_name_latin"
                                    )
                                      ? _c(
                                          "div",
                                          { staticClass: "form__error" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.hasErrorMessage(
                                                    "newAgent_last_name_latin"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-lg-6" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form__col",
                                    class: _vm.hasError("newAgent_patronymic"),
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.get_translation_constant(
                                            "text_patronymic_cyrillic"
                                          )
                                        ) +
                                          "\n                                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newAgent.patronymic,
                                          expression: "newAgent.patronymic",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        name: "full_name_ro",
                                        placeholder:
                                          _vm.get_translation_constant(
                                            "text_patronymic"
                                          ),
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.newAgent.patronymic,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.newAgent,
                                            "patronymic",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.hasErrorMessage(
                                      "newAgent_text_patronymic"
                                    )
                                      ? _c(
                                          "div",
                                          { staticClass: "form__error" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.hasErrorMessage(
                                                    "newAgent_text_patronymic"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                            ]
                          : [
                              _c("div", { staticClass: "col-12 col-lg-6" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form__col",
                                    class: _vm.hasError(
                                      "newAgent_first_name_latin"
                                    ),
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.get_translation_constant(
                                            "text_firstname_latin"
                                          )
                                        ) +
                                          "\n                                            "
                                      ),
                                      _c("sup", [_vm._v("*")]),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newAgent.first_name_latin,
                                          expression:
                                            "newAgent.first_name_latin",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        name: "full_name_ro",
                                        placeholder:
                                          _vm.get_translation_constant(
                                            "text_firstname_latin"
                                          ),
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.newAgent.first_name_latin,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.newAgent,
                                            "first_name_latin",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.hasErrorMessage(
                                      "newAgent_first_name_latin"
                                    )
                                      ? _c(
                                          "div",
                                          { staticClass: "form__error" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.hasErrorMessage(
                                                    "newAgent_first_name_latin"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-lg-6" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form__col",
                                    class: _vm.hasError(
                                      "newAgent_last_name_latin"
                                    ),
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.get_translation_constant(
                                            "text_lastname_latin"
                                          )
                                        ) +
                                          "\n                                            "
                                      ),
                                      _c("sup", [_vm._v("*")]),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newAgent.last_name_latin,
                                          expression:
                                            "newAgent.last_name_latin",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        name: "full_name_ro",
                                        placeholder:
                                          _vm.get_translation_constant(
                                            "text_lastname_latin"
                                          ),
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.newAgent.last_name_latin,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.newAgent,
                                            "last_name_latin",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.hasErrorMessage(
                                      "newAgent_last_name_latin"
                                    )
                                      ? _c(
                                          "div",
                                          { staticClass: "form__error" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.hasErrorMessage(
                                                    "newAgent_last_name_latin"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-lg-6" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form__col",
                                    class: _vm.hasError("newAgent_first_name"),
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.get_translation_constant(
                                            "text_firstname_english"
                                          )
                                        ) +
                                          "\n                                            "
                                      ),
                                      _c("sup", [_vm._v("*")]),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newAgent.first_name,
                                          expression: "newAgent.first_name",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        name: "full_name_ro",
                                        placeholder:
                                          _vm.get_translation_constant(
                                            "text_firstname_english"
                                          ),
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.newAgent.first_name,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.newAgent,
                                            "first_name",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.hasErrorMessage("newAgent_first_name")
                                      ? _c(
                                          "div",
                                          { staticClass: "form__error" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.hasErrorMessage(
                                                    "newAgent_first_name"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-lg-6" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form__col",
                                    class: _vm.hasError("newAgent_last_name"),
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.get_translation_constant(
                                            "text_lastname_english"
                                          )
                                        ) +
                                          "\n                                            "
                                      ),
                                      _c("sup", [_vm._v("*")]),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newAgent.last_name,
                                          expression: "newAgent.last_name",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        name: "full_name_ro",
                                        placeholder:
                                          _vm.get_translation_constant(
                                            "text_lastname_english"
                                          ),
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.newAgent.last_name,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.newAgent,
                                            "last_name",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.hasErrorMessage("newAgent_last_name")
                                      ? _c(
                                          "div",
                                          { staticClass: "form__error" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.hasErrorMessage(
                                                    "newAgent_last_name"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-lg-6" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form__col",
                                    class: _vm.hasError("newAgent_patronymic"),
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.get_translation_constant(
                                            "text_patronymic"
                                          )
                                        ) +
                                          "\n                                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newAgent.patronymic,
                                          expression: "newAgent.patronymic",
                                        },
                                      ],
                                      staticClass: "form__control",
                                      attrs: {
                                        name: "full_name_ro",
                                        placeholder:
                                          _vm.get_translation_constant(
                                            "text_patronymic"
                                          ),
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.newAgent.patronymic,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.newAgent,
                                            "patronymic",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.hasErrorMessage(
                                      "newAgent_text_patronymic"
                                    )
                                      ? _c(
                                          "div",
                                          { staticClass: "form__error" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.hasErrorMessage(
                                                    "newAgent_text_patronymic"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                            ],
                        _vm._v(" "),
                        _vm.account.location_id !== 1
                          ? _c("div", { staticClass: "col-12 col-lg-6" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form__col",
                                  class: _vm.hasError("newAgent_city"),
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.get_translation_constant(
                                          "text_your_city"
                                        )
                                      ) + " "
                                    ),
                                    _c("sup", [_vm._v("*")]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "multiselect",
                                    {
                                      staticClass: "form-control",
                                      attrs: {
                                        multiple: false,
                                        placeholder:
                                          _vm.get_translation_constant(
                                            "text_choose_city"
                                          ),
                                        options: _vm.cities,
                                        label: "title",
                                        selectLabel: "",
                                        deselectLabel: "",
                                        optionHeight: 48,
                                        showPointer: true,
                                      },
                                      model: {
                                        value: _vm.newAgent.city,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.newAgent, "city", $$v)
                                        },
                                        expression: "newAgent.city",
                                      },
                                    },
                                    [void 0],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _vm.hasErrorMessage("newAgent_city")
                                    ? _c(
                                        "div",
                                        { staticClass: "form__error" },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.hasErrorMessage(
                                                  "newAgent_city"
                                                )
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("newAgent_street"),
                            },
                            [
                              _c("label", { attrs: { for: "address" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_your_street"
                                    )
                                  ) +
                                    "\n                                        "
                                ),
                                _c("sup", [_vm._v("*")]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.newAgent.street,
                                    expression: "newAgent.street",
                                  },
                                ],
                                staticClass: "form__control",
                                attrs: {
                                  name: "street",
                                  type: "text",
                                  placeholder:
                                    _vm.get_translation_constant(
                                      "text_your_street"
                                    ),
                                },
                                domProps: { value: _vm.newAgent.street },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.newAgent,
                                      "street",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasErrorMessage("newAgent_street")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.hasErrorMessage("newAgent_street")
                                        ) +
                                        "\n                                    "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("newAgent_house"),
                            },
                            [
                              _c("label", { attrs: { for: "house" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_your_house"
                                    )
                                  ) +
                                    "\n                                        "
                                ),
                                _c("sup", [_vm._v("*")]),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.newAgent.house,
                                    expression: "newAgent.house",
                                  },
                                ],
                                staticClass: "form__control",
                                attrs: {
                                  name: "house",
                                  id: "house",
                                  type: "text",
                                  placeholder:
                                    _vm.get_translation_constant(
                                      "text_your_house"
                                    ),
                                },
                                domProps: { value: _vm.newAgent.house },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.newAgent,
                                      "house",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasErrorMessage("newAgent_house")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.hasErrorMessage("newAgent_house")
                                        ) +
                                        "\n                                    "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form__col",
                              class: _vm.hasError("newAgent_apartment"),
                            },
                            [
                              _c("label", { attrs: { for: "apartment" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "text_your_apartment"
                                    )
                                  ) +
                                    "\n                                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.newAgent.apartment,
                                    expression: "newAgent.apartment",
                                  },
                                ],
                                staticClass: "form__control",
                                attrs: {
                                  name: "apartment",
                                  id: "apartment",
                                  type: "text",
                                  placeholder: _vm.get_translation_constant(
                                    "text_your_apartment"
                                  ),
                                },
                                domProps: { value: _vm.newAgent.apartment },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.newAgent,
                                      "apartment",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.hasErrorMessage("newAgent_apartment")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.hasErrorMessage(
                                            "newAgent_apartment"
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.account.location_id === 1
                          ? _c("div", { staticClass: "col-12 col-lg-6" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form__col",
                                  class: _vm.hasError("newAgent_postcode"),
                                },
                                [
                                  _c("label", { attrs: { for: "postcode" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.get_translation_constant(
                                          "text_your_postcode"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.newAgent.postcode,
                                        expression: "newAgent.postcode",
                                      },
                                    ],
                                    staticClass: "form__control",
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.get_translation_constant(
                                        "text_enter_postcode"
                                      ),
                                    },
                                    domProps: { value: _vm.newAgent.postcode },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.newAgent,
                                          "postcode",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.hasErrorMessage("newAgent_postcode")
                                ? _c("div", { staticClass: "form__error" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.hasErrorMessage(
                                            "newAgent_postcode"
                                          )
                                        ) +
                                        "\n                                "
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-lg-6" }, [
                        _c(
                          "div",
                          {
                            staticClass: "form__col",
                            class:
                              _vm.hasError("newAgent_phone_prefix") ||
                              _vm.hasError("newAgent_phone_number"),
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.get_translation_constant("text_phone")
                                ) + " "
                              ),
                              _c("sup", [_vm._v("*")]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "phone__block" },
                              [
                                _c("multiselect", {
                                  staticClass: "form-control",
                                  attrs: {
                                    multiple: false,
                                    placeholder: "",
                                    options: _vm.locationPrefixes,
                                    label: "title",
                                    selectLabel: "",
                                    deselectLabel: "",
                                    optionHeight: 48,
                                    showPointer: true,
                                    searchable: false,
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "singleLabel",
                                      fn: function (props) {
                                        return [
                                          _c("img", {
                                            staticClass: "option__image",
                                            attrs: {
                                              src: props.option.image,
                                              width: "16",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "option__title" },
                                            [_vm._v(_vm._s(props.option.title))]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "option",
                                      fn: function (props) {
                                        return [
                                          _c("img", {
                                            staticClass: "option__image",
                                            attrs: {
                                              src: props.option.image,
                                              width: "16",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "option__title" },
                                            [_vm._v(_vm._s(props.option.title))]
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                  model: {
                                    value: _vm.newAgent.phone_prefix,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.newAgent,
                                        "phone_prefix",
                                        $$v
                                      )
                                    },
                                    expression: "newAgent.phone_prefix",
                                  },
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newAgent.phone_number,
                                      expression: "newAgent.phone_number",
                                    },
                                  ],
                                  staticClass: "form__control type_tel",
                                  attrs: { type: "tel" },
                                  domProps: {
                                    value: _vm.newAgent.phone_number,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.newAgent,
                                        "phone_number",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.hasErrorMessage("newAgent_phone_prefix") ||
                                _vm.hasError("newAgent_phone_number")
                                  ? _c("div", { staticClass: "form__error" }, [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(
                                            _vm.hasErrorMessage(
                                              "newAgent_phone_prefix"
                                            )
                                          ) +
                                          "\n                                            " +
                                          _vm._s(
                                            _vm.hasErrorMessage(
                                              "newAgent_phone_number"
                                            )
                                          ) +
                                          "\n                                        "
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 col-lg-6" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "form__col form__col_no_label text-right",
                          },
                          [
                            _c("input", {
                              staticClass: "btn btn__large btn__green no_width",
                              attrs: { type: "submit" },
                              domProps: {
                                value:
                                  _vm.get_translation_constant(
                                    "text_add_agent"
                                  ),
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.addAgent()
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("alert-modal", {
        attrs: {
          title: _vm.modalTitle,
          type: _vm.modalType,
          message: _vm.modalMessage,
          modalId: _vm.modalId,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }